import CustomRadioGroup from "@/components/inputs/custom-radio-group";
import CustomTextArea from "@/components/inputs/custom-textarea";
import { Button } from "@/components/ui/button";
import { FieldLegend, FieldSet } from "@/components/ui/field";
import { useQualifyVouchMutation } from "@/hooks/use-qualify-vouch-mutation";
import {
  CONFIRMATION_OPTIONS,
  countVouchLetters,
  MIN_VOUCH_LETTERS,
  RECOMMENDATION_OPTIONS,
} from "@/lib/constants";
import { Spinner } from "../ui/spinner";

const VouchQualifyForm = ({ voucheeName }: { voucheeName?: string }) => {
  const {
    accuracyValue,
    endorsementValue,
    comments,
    fieldError,
    updateMeta,
    handleSubmit,
    isSubmitting,
    isSubmitDisabled,
  } = useQualifyVouchMutation(voucheeName);

  const hasNegativeAnswer = accuracyValue === "no" || endorsementValue === "no";

  const commentsLetterCount = countVouchLetters(comments);
  const shouldHideCounter = commentsLetterCount >= MIN_VOUCH_LETTERS;

  return (
    <form onSubmit={handleSubmit} className="flex w-full flex-col gap-6">
      <FieldSet disabled={isSubmitting} className="w-full">
        <FieldLegend variant="legend">
          Are these details accurate?
        </FieldLegend>
        <CustomRadioGroup
          name="Accuracy"
          options={CONFIRMATION_OPTIONS}
          className="grid grid-cols-1 gap-2 sm:grid-cols-2"
          value={accuracyValue}
          onValueChange={(val) => updateMeta({ Accuracy: val === "yes" })}
        />
      </FieldSet>

      <FieldSet disabled={isSubmitting} className="w-full">
        <FieldLegend>
          Would you recommend {voucheeName} for marriage?
        </FieldLegend>
        <CustomRadioGroup
          name="Endorsement"
          options={RECOMMENDATION_OPTIONS}
          className="grid grid-cols-1 gap-2 sm:grid-cols-2"
          value={endorsementValue}
          onValueChange={(val) => updateMeta({ Endorsement: val === "yes" })}
        />
      </FieldSet>

      {hasNegativeAnswer && (
        <FieldSet disabled={isSubmitting} className="animate-reason w-full">
          <CustomTextArea
            label="What's not right?"
            id="Comments"
            name="Comments"
            placeholder={`This won't appear on ${voucheeName}'s profile.`}
            rows={5}
            className="bg-background"
            value={comments}
            onChange={(e) => updateMeta({ Comments: e.target.value })}
            error={fieldError.Comments}
            showCounter={!shouldHideCounter}
            count={commentsLetterCount}
            countLimit={MIN_VOUCH_LETTERS}
          />
        </FieldSet>
      )}

      <Button
        size="xl"
        type="submit"
        disabled={isSubmitDisabled || isSubmitting}
        className="w-full sm:w-auto "
      >
        {isSubmitting ? (
          <>
            <Spinner data-icon="inline-start" />
            Submitting
          </>
        ) : hasNegativeAnswer ? (
          "Finish"
        ) : (
          "Next"
        )}
      </Button>
    </form>
  );
};

export default VouchQualifyForm;
